import { useCallback, useEffect, useState } from 'react';

const DISABLE_SCROLL_CLASS_NAME = 'disable-scroll';

const useModal = (init?: boolean): [boolean, (bool: boolean) => void] => {
  // iOS Safariのモーダル表示に`position: fixed`にする必要があり、
  // スクロール位置をJSで管理する必要があるため、scrollYの値を取得する
  const { scrollX, scrollY } = window;
  const [isActive, setIsActive] = useState<boolean>(init || false);
  const [scrolledPosition, setScrolledPosition] = useState<[number, number]>([
    scrollX,
    scrollY,
  ]);

  useEffect(() => {
    const enableScroll = () => {
      document.documentElement.classList.remove(DISABLE_SCROLL_CLASS_NAME);
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.width = '';
      window.scrollTo(scrolledPosition[0], scrolledPosition[1]);
    };

    if (isActive) {
      setScrolledPosition([scrollX, scrollY]);
      document.documentElement.classList.add(DISABLE_SCROLL_CLASS_NAME);
      document.body.style.left = `-${scrollX}px`;
      document.body.style.top = `-${scrollY}px`;
      document.body.style.width = '100%';
    } else {
      enableScroll();
    }

    return enableScroll;
  }, [isActive]);

  return [isActive, useCallback((bool: boolean) => setIsActive(bool), [])];
};

export default useModal;
